import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATES_APPROVED_PERMISSIONS } from '@modules/affiliates-approved/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IHistoryOfTrackerGroupsChanges } from '../types';
import {
  AFFILIATE_SHOW_HISTORY_TRACKER_GROUPS_API_URL,
  AFFILIATE_SHOW_HISTORY_TRACKER_GROUPS_QUERY,
} from '../constants';

export default function useShowHistoryOfTrackerGroupsQuery(id: Ref<number>): IContextQueryResult<
  IHistoryOfTrackerGroupsChanges
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IHistoryOfTrackerGroupsChanges>({
    queryKey: [AFFILIATE_SHOW_HISTORY_TRACKER_GROUPS_QUERY, id],
    queryFn: ({ signal }) => fetchGet<IHistoryOfTrackerGroupsChanges>(
      AFFILIATE_SHOW_HISTORY_TRACKER_GROUPS_API_URL,
      {
        signal,
        permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    enabled: computed(() => !!id.value),
  });
}
